import { Button } from '@nexelem/components';
import { StepperHeader } from '../../../../atoms/FormStepper/StepperHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { GenerateSimulationButton } from '.';
import { useCustomTranslation } from '../../../../../hooks';
import { AvailabilityArea } from './AvailabilityArea';

type GanttSimulationAvailabilityProps = {
  onChangeStep: () => void;
  cancelButton: React.ReactNode;
  submitButtonLabel: string;
};

export const GanttSimulationAvailability = ({
  onChangeStep,
  cancelButton,
  submitButtonLabel,
}: GanttSimulationAvailabilityProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <StepperHeader
        currentStepIndex={1}
        stepsCount={2}
        subtitle={tWrapper('stepTwoAvailability')}
        title={tWrapper('newSimulationForDates', { date: '7-21.02.2025' })} // TODO: add correct dates
      />

      <div className="flex-1 overflow-auto px-8 py-9">
        <div className="flex flex-col gap-2">
          <AvailabilityArea />
          <AvailabilityArea />
          <AvailabilityArea />
          <AvailabilityArea />
          <AvailabilityArea />
        </div>
      </div>

      <div className="flex items-center justify-between border-t border-border-primary px-8 py-2">
        <span className="text-s18">{tWrapper('stepTwoAvailability')}</span>
        <div className="flex gap-4">
          {cancelButton}
          <Button StartIcon={<FontAwesomeIcon icon={faArrowLeft} />} variant="outlined" onClick={onChangeStep}>
            {tWrapper('backToParameters')}
          </Button>
          <GenerateSimulationButton submitButtonLabel={submitButtonLabel} />
        </div>
      </div>
    </div>
  );
};
